import React from 'react';
import AddDealership from 'components/pages/Home/DealershipTab/AddDealership';

const DealershipMiddleContent = () => <AddDealership />;

export default DealershipMiddleContent;
